export const emailSignature = `
<div>

    <p>
        Sincerely, <br><br>
        Philip | CEO | Swift CSV
    </p>

    <p>
        T: +27 66 203 8585 <br>
        E: admin@swiftcsv.com <br>
        Office hours: 08h30 – 16h30 (Mon – Fri) <br>
    </p>

    <div>
        <img src="https://firebasestorage.googleapis.com/v0/b/swift-csv-prod.appspot.com/o/assets%2FSwiftCSVLogo.png?alt=media&token=e99b73a8-d25b-4970-b7ba-94984121fe2a" width="200px">
    </div>
</div>
`;
